import { getModeFromComponents } from './xcspec_helpers';

/**
 * Get XMOD device mode from components
 * @param components - Array of component strings (e.g., ['switch:0', 'light:1'])
 * @returns Mode string (e.g., 'relay', 'light', 'cct', 'inputs_reader', 'shell')
 */
export function getXMODMode(components: string[]): string {
	if (!components || components.length === 0) {
		return 'shell';
	}

	return getModeFromComponents(components) || 'shell';
}
